import { app } from '../../../../../app';
import { appProtocolDisplayName } from '../../../../../../util/sp-util';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.applications', {
        url: '/applications',
        component: 'companyUserDirectoriesManageGroupApplications',
        resolve: {
            applications,
        },
    });
}

/** @ngInject */
function applications(companyId, groupId, GroupsResource) {
    return GroupsResource.getAssignedApplicationsOfGroup(companyId, groupId)
        .then(applications => applications.map(app => ({...app, protocol: appProtocolDisplayName(app)})));
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/applications/group-applications.state.js